import PropTypes from 'prop-types';
import { useField } from 'formik';

import useInput from '../hooks/useInput';
import TeethOdontoGram from './TeethSelector/TeethOdontoGram';
import { FDI } from './TeethSelector/nomenclatures';

export function FormikTeethOdontoGram(
  {
    id: defaultId,
    name,
    value = [],
    label,
    isChild,
    typeNomenclature = FDI,
    disabled
  }
) {
  const [, meta, helper] = useField({
    name,
    value
  });
  const { id } = useInput(defaultId, label);
  return (
    <TeethOdontoGram
      id={id}
      name={name}
      value={value || meta.value}
      isChild={isChild}
      typeNomenclature={typeNomenclature}
      onChange={helper.setValue}
      disabled={disabled}
    />
  );
}

FormikTeethOdontoGram.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.array,
  label: PropTypes.string,
  isChild: PropTypes.bool,
  typeNomenclature: PropTypes.string,
  disabled: PropTypes.bool
};

export default FormikTeethOdontoGram;
